import { render, staticRenderFns } from "./order_wait_delivery_list.vue?vue&type=template&id=2da3946e&scoped=true"
import script from "./order_wait_delivery_list.vue?vue&type=script&lang=js"
export * from "./order_wait_delivery_list.vue?vue&type=script&lang=js"
import style0 from "./order_wait_delivery_list.vue?vue&type=style&index=0&id=2da3946e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da3946e",
  null
  
)

export default component.exports